module.exports = __webpack_public_path__ + "img/hr-pipe-ending-up.f22a63d8.png";